import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { Tooltip, QRCode } from "antd";
import { productApi } from "@/apis";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { backToTop } from "@/utils/dom";
import consultPng from "@/images/product/comment.png";
import defaultPng from "@/images/product/default.png";
import sharePng from "@/images/product/share-icon.png";
import "./index.less";

// TODO: 优化多商品切换功能

let targetUrl = "http://crm.yingde.com:8105/";

if (/nshopuat.yingde.com/.test(window.location.origin)) {
  targetUrl = "http://crmuat.yingde.com:8105/";
}

const Detail = () => {
  const { id = "" } = useParams();
  const [curPicUrl, setCurPicUrl] = useState("");
  const [productDetail, setProductDetail] = useState<ProductInfo>();
  const [productList, setProductList] = useState<ProductInfo[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    productApi
      .getProductDetail({
        id,
      })
      .then((res) => {
        const { pictureMediaList } = res;
        const fileCode = (pictureMediaList || [])[0]?.fileCode;
        const curPicUrl = fileCode
          ? `/crm-venus/v1/venus/images/${fileCode}.id`
          : "";
        setCurPicUrl(curPicUrl);
        setProductDetail(res);
      });
    backToTop();
  }, [id]);

  // 获取推荐产品
  useEffect(() => {
    productApi
      .getProductList({
        enableStatus: "009",
        isShelf: "Y",
        page: 1,
        size: 4,
      })
      .then((res) => {
        const { records } = res;
        setProductList(records);
      });
  }, []);

  useEffect(() => {
    if (productDetail || (productList && productList.length)) {
      if ((window as any).zc) {
        (window as any).zc("dynamic_ready");
      }
    }
  }, [productDetail, productList]);

  const toDetailPage = useCallback(
    (id: string) => {
      navigate(`/good/detail/${id}`);
    },
    [navigate]
  );

  return (
    <div className="max-width">
      <div className="product-detail-wrapper">
        <div className="detail-info">
          <div className="left">
            <img src={curPicUrl} alt="" />
            <div className="img-list-wrapper flex-b-c">
              <LeftOutlined className="pointer" />
              <div className="img-list">
                <img src={curPicUrl} alt="" className="pointer" />
              </div>
              <RightOutlined className="pointer" />
            </div>
          </div>
          <div className="right">
            <div>
              <h4>{productDetail?.productName}</h4>
              <p>
                <span>规格：</span>
                {productDetail?.spec}
              </p>
            </div>
            <div className="right-bottom">
              <div className="consult pointer zcbtn flex-c-c">
                <img src={consultPng} alt="" />
                <span>咨询</span>
              </div>
              <Tooltip
                // open
                color="#ffffff"
                title={
                  <div className="tooltip-content">
                    <QRCode
                      className="QRCode-content"
                      size={140}
                      value={`${targetUrl}crm-product-h5?productId=${id}`}
                    />
                    <p>请使用手机扫码进行分享</p>
                  </div>
                }
              >
                <div className="share-box pointer flex-c-c">
                  <img src={sharePng} alt="" />
                  <span>分享</span>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="product-introduce-wrapper">
          <p className="title">产品介绍</p>
          <div className="dividing"></div>
          <div
            className="content"
            dangerouslySetInnerHTML={{
              __html:
                productDetail?.introduction?.introductionText || "暂无产品介绍",
            }}
          ></div>
        </div>
      </div>
      {productList && productList.length > 0 ? (
        <div className="product-recommend-wrapper">
          <h4>
            <span>推荐产品</span>
          </h4>
          <ul className="goods-list">
            {productList.map(({ id, productName, pictureMediaList, spec }) => (
              <li key={id}>
                <h4 onClick={() => toDetailPage(id)}>{productName}</h4>
                <div className="info">
                  <div className="pointer" onClick={() => toDetailPage(id)}>
                    <img
                      src={
                        pictureMediaList
                          ? `/crm-venus/v1/venus/images/${pictureMediaList[0]?.fileCode}.id`
                          : defaultPng
                      }
                      alt=""
                    />
                    <p>规格：{spec}</p>
                  </div>
                  <div className="consult pointer zcbtn flex-c-c">
                    <img src={consultPng} alt="" />
                    <span>咨询</span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Detail;
